import {
  UserAssigneesData,
  UserInfo,
} from "../../SharedModule/types/shared-module-types";
import HttpService from "../../SharedModule/utils/api";
import { User } from "../types/users-module-types";
const BASE_URL = "/users";

function getUsers(): Promise<User[]> {
  return HttpService.req(`${BASE_URL}/Users`);
}

function getUserProfileInfo(mail: any): Promise<UserInfo> {
  return HttpService.req(`${BASE_URL}/Users/user-details/${mail}`);
}

function getUserProfileInfoByAzureObjectId(azureObjectId: string): Promise<UserInfo> {
  return HttpService.req(
    `${BASE_URL}/Users/user-details/by-azure-object-id/${azureObjectId}`,
  );
}

function getUserAssignees(id: string): Promise<UserAssigneesData> {
  return HttpService.req(`${BASE_URL}/Users/${id}/assignees`);
}

function getUserDetails(id: string): Promise<any> {
  return HttpService.req(`${BASE_URL}/Users/${id}/details`);
}

function getUserList(): Promise<any> {
  return HttpService.req(`${BASE_URL}/Users/ListUsers`);
}

function getUsersWithProfileInfo(id?: number): Promise<any> {
  const base = `${BASE_URL}/Users/GetUsersWithProfileInfo?onlyActive=false`;
  return HttpService.req(id ? `${base}&employeeId=${id}` : base);
}

function getCostCenters(): Promise<any> {
  return HttpService.req(`${BASE_URL}/CostCenters/WithChildren`);
}

function updateUserSettings(id: string, body: any): Promise<any> {
  return HttpService.req({
    method: "put",
    url: `${BASE_URL}/Users/${id}/profile`,
    data: { ...body },
  });
}

function getCostCentersOwned(email: any): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/CostCenters/${email}/cost-centers-owned`,
  });
}

function getSupervisors(): Promise<any> {
  return HttpService.req(`${BASE_URL}/Users/Supervisors`);
}

function importAzureUsers(): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/Users/ImportAzureUsers`,
  });
}

export const UsersService = {
  getUsers,
  getUserProfileInfo,
  getUserProfileInfoByAzureObjectId,
  getUserAssignees,
  getUserDetails,
  getUserList,
  getUsersWithProfileInfo,
  getCostCenters,
  updateUserSettings,
  getCostCentersOwned,
  getSupervisors,
  importAzureUsers,
};
